import { businessPlanAxios } from 'services/controllers/businessPlan';

import * as t from './types';

export const BalanceSheetApi = {
  getPpeAssetsCalculations: async (params: t.IPpeAssetsCalculationsParams) => {
    const { businessPlanId, unit, ppeAssetsData  } = params;
    const { data } = await businessPlanAxios.put<t.IProductionCalculationResponse>(
      `/${businessPlanId}/balancesheet/ppeintangible/${unit}`,
      ppeAssetsData,
    );
    return data;
  },
};
